export const PartnerKey = {
  HEALTHJOY: 'HealthJoy',
};
